var m = require('mithril')
var eventHelper = require('../helpers/EventHelper')
var utils = require('../helpers/Utils')
var user = require('../models/User')

var MyPhotosPictures = {
    _indexStartToShow : 0,
    _pictureToShow : 2*3, // 2 is column 3 is row, the only editable is column. For change the number of row you need to edit the css
    oninit : function(vnode){
        MyPhotosPictures.setIndexToShow(0)
    },
    onbeforeremove : function(e){
        e.dom.classList.add("basic-exit-scale")
        /*var flexItems = document.getElementById("table-pictures-container").getElementsByClassName("flex-item")
        for (var i = 0; i < flexItems.length; i++) {
            flexItems[i].style.opacity = "0"
        }*/
        return utils.waitBeforeElementUpdate(e.dom)
        
    },
    checkPicturesEndLoad : function(ib){
        var flexItem = utils.findAncestor(ib.target, "flex-item")
        flexItem.style.opacity = "1"
    },
    oncreate : function(e){
        var pictures = e.dom.getElementsByTagName("img")
        var that = this
        for (var i = 0; i < pictures.length; i++) {
            var index = i
            pictures[i].onload = function(e){
                that.checkPicturesEndLoad(e)
            }
        }
    },
    setIndexToShow : function(index){
        MyPhotosPictures._indexStartToShow = index
        var photos = user.current.artiste.photos
        var minSlice = MyPhotosPictures._indexStartToShow
        var maxSlice = MyPhotosPictures._indexStartToShow + this._pictureToShow
        MyPhotosPictures.pictures = photos.slice(minSlice,maxSlice)
    },
    view: function(ctrl) {
        var that = this
        return m("div", {class:"element-table-container", id:"table-pictures-container"},[
            MyPhotosPictures.pictures.map(function(item, i){
                var selected = item.selected
                var src = item.src
                return m("div", {
                    class: selected ? "flex-item selected" : "flex-item",
                    onclick: function(e){
                        var index = 0;
                        user.current.artiste.photos.map(function(x, ide){ // Limit the selection to 1 picture
                            if(x.selected === true){
                                user.current.artiste.photos[ide].selected = false
                            }
                            x.id === item.id ? index = ide : null
                        })

                        user.current.artiste.photos[index].selected = !selected
                    }
                },[
                    m("div", {class: "rounded-container picture"},[
                        that.getBgOnSelectedPictures(selected),
                        m("img", { 
                            alt: user.current.personne.fullname,
                            src: src
                        }),
                    ])
                ]) 
            })
        ])
    },
    getBgOnSelectedPictures(selected){
        if(selected){
            return m("span", {class:"container-on-select"},[
                m("span", {class:"select-ico-container"},[
                    m("i", {class:"fas fa-check"})
                ]),
                m("span", {class:"black-bg-100"}),
            ])
        }
    }
}

module.exports = MyPhotosPictures
